import React from "react";
import { observer } from "mobx-react";
import { NavLink } from 'reactstrap'
import SurveySection from './SurveySection';
import store from './Stores/SurveyStore';
import { getExcelTemplateCtrl, unlockSurveyCtrl } from "../control"
import {CURRENT_DATA_YEAR, HISTORICAL_BASE_YEAR} from '../Enums/constants';
import GenericHomeDetails from "./GenericHomeDetails";
import IbsSurveyStore from "./Stores/IbsSurveyStore";
import { checkIfAnalyst } from "../Services/PABS/PabsService";

const GenericHomePage = observer((props) => {
    const contacts = props.contacts;
    let contactsLine = "your contact at CEM Benchmarking INC."
    if (contacts && contacts.length > 0) {
    contactsLine = contacts
      .map(c => {
        let details = c.name;
        if (c.phone && c.email) {
          details += ` (${c.phone} or ${c.email})`;
        } else if (c.phone) {
          details += ` (${c.phone})`;
        } else if (c.email) {
          details += ` (${c.email})`;
        }
        return details;
      })
      .join(contacts.length > 2 ? ', ' : ' or ');
      if (contacts.length > 2) {
        // Replace last comma with ", or"
        contactsLine = contactsLine.replace(/, ([^,]*)$/, ', or $1');
      }
      contactsLine += '.';
    }

    const dueDate = props.dueDate || "next year";

    const historicalAccessYears = CURRENT_DATA_YEAR - HISTORICAL_BASE_YEAR + 1;
    
    let infoText
    if (IbsSurveyStore.accountInfo && IbsSurveyStore.accountInfo.UserRoleID === 3 && window.location.href.includes("/ibs/home")) {
        window.location.href = "/ibs/laundromat"
    }
    else if (window.location.href.includes("/ibs") || window.location.href.includes("/dc")) {
        infoText = <React.Fragment>The appearance and functionality of the survey has been enhanced. Enhancements include:
            <br />
            1. Access to historical submissions for up to {historicalAccessYears} years.
            <br />
            2. Ability to print your submission to PDF. Use the <i id="PrintNavButton" className="fas fa-print" title="Print" style={{ color: "#1a71c1", cursor: "unset" }}></i> button on the top right of this page.
            <br />
            3. Improved validations allowing you to provide commentary and speed up the data review process.
            <br />
            <br />
            Your survey responses have been preserved in the new format.
            <br />
            <br />
            All data is saved automatically as you work.
            { store.isAvailableSurveysEmpty? <>
            <br />
            <br /> 
            No surveys available.
            </> : null }
            </React.Fragment>
    }
    else if (window.location.href.includes("/db")) {
        infoText = <React.Fragment>The appearance and functionality of the survey has been enhanced. Enhancements include:
            <br />
            1. Access to historical submissions for up to three years.
            <br />
            2. Ability to print your submission to PDF. Use the <i id="PrintNavButton" className="fas fa-print" title="Print" style={{ color: "#1a71c1", cursor:"unset" }}></i> button on the top right of this page.
            <br />
            3. Improved validations allowing you to provide commentary and speed up the data review process.
            <br />                        
            4. Option to provide holdings by mandates.
            <br /><br />
            Your survey responses have been preserved in the new format.
            <br /><br />
            All data is saved automatically as you work.</React.Fragment>
    }
    else if (window.location.href.includes("/pabsuk")) {

        infoText = <React.Fragment>
            <p>
                Welcome to the CEM pension administration benchmarking survey.  You do not have to complete everything in one sitting. All data is saved automatically as you work. The confidentiality of your data will be strictly maintained.
            </p>
            <p>
                All questions relate to the fiscal year ending March 31, {store.currentYear}. (Or your most recent year end)
            </p>
            <p>
                Enter ‘n/a’ only if the question is not applicable to your plan. Enter ‘unknown’ if unknown. You may provide estimates if you do not have hard data, but only if the basis for the estimate is reasonable.
            </p>
            <p>
                If you have questions or require clarification, please contact {contactsLine}
            </p>
            <p>
                The due date is {dueDate}. If you cannot submit the survey by this due date, please let us know.
            </p>
            <p>
                If you would like to download a copy of the survey with last year's answers {" "}
                <button
                    type="button"
                    style={{
                        textDecoration: 'none',
                        border: 'none',
                        background: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        color: '#0055b3',
                        fontSize: 'inherit',
                        fontFamily: 'inherit'
                    }}
                    onClick={getExcelTemplateCtrl}
                >
                    click here
                </button>

                .
            </p>
            {((store.currentSurvey?.SurveyStatusTypeId !== 1 || checkIfAnalyst()) && store.currentSurvey?.IsReadOnly) && (
                <NavLink
                    onClick={() => unlockSurveyCtrl()}
                    className='btn btn-unlock'>
                    Unlock Survey
                </NavLink>
            )}
        </ React.Fragment>
    } 
    else if (window.location.href.includes('/pabs')) {
        infoText = (
            <React.Fragment>
                Welcome to the CEM pension administration benchmarking survey. To access
                the survey click on the {store.currentYear} survey link below. You do not have to
                complete everything in one sitting. All data is saved automatically as
                you work. The confidentiality of your data will be strictly maintained.
                <br />
                <br />
                All questions pertain to the fiscal year ending {store.currentYear}.
                <br />
                <br />
                Enter ‘n/a’ only if the question is not applicable to your plan. Enter
                ‘unknown’ if unknown. You may provide estimates if you do not have hard
                data, but only if the basis for the estimate is reasonable. If you
                cannot provide an answer, we will apply a default.
                <br />
                <br />
                If you have questions or require clarification, please contact: Yvette
                van Velsen by email at{' '}
                <a href='mailto:Yvette@explorecem.com'>
                    Yvette@explorecem.com
                </a>{' '}
                to set up a meeting.
                <br />
                <br />
                The due date is {dueDate}. If you cannot submit the survey by this
                due date, please let us know.
                <p>
                    We encourage you to complete the survey online. However, if you prefer
                    the Excel version to assist with your internal processes, please{' '}
                    <button
                        type='button'
                        style={{
                            textDecoration: 'none',
                            border: 'none',
                            background: 'none',
                            padding: 0,
                            cursor: 'pointer',
                            color: '#1d88c8',
                            fontSize: 'inherit',
                            fontFamily: 'inherit',
                        }}
                        onClick={getExcelTemplateCtrl}
                    >
                        click here
                    </button>
                    .
                </p>
                {((store.currentSurvey?.SurveyStatusTypeId !== 1 || checkIfAnalyst()) && store.currentSurvey?.IsReadOnly) && (
                    <NavLink
                    onClick={() => unlockSurveyCtrl()}
                    className='btn btn-unlock'>
                    Unlock Survey
                    </NavLink>
                )}
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <SurveySection labelText={'Welcome to the ' + props.surveyCategoryName}>
                <div style={{ whiteSpace: 'pre-line' }}>{infoText}</div>
            </SurveySection>

            <GenericHomeDetails/>

        </React.Fragment>
    )
        })
        
export default GenericHomePage
  